import {AbstractControl} from '@angular/forms';
import {Condition} from '../interfaces/condition.interface';
import {ConditionsConjuntion} from '../enums/conditions-conjuntion.enum';
import {FormField} from '../interfaces/form-field.interface';
import {Operator} from '../enums/operator.enum';
import {FormFieldTypeOptions} from '../types/form-field-type-options.type';

export class FieldCondtitionUtils {
  public static areConditionsMet(
    conditions: Condition[],
    conjunction: string,
    formControls: {
      [key: string]: AbstractControl;
    },
    formFields: FormField[],
  ): boolean {
    if (conditions && conditions.length > 0) {
      let allConditions: boolean;
      conditions.forEach((condition, index) => {
        if (index === 0) {
          allConditions = this.generateCondition(condition, formControls, formFields);
        } else if (index > 0 && conjunction === ConditionsConjuntion.AND) {
          allConditions = allConditions && this.generateCondition(condition, formControls, formFields);
        } else if (index > 0 && conjunction === ConditionsConjuntion.OR) {
          allConditions = allConditions || this.generateCondition(condition, formControls, formFields);
        }
      });
      return allConditions;
    } else {
      return true;
    }
  }

  private static generateCondition(
    condition: Condition,
    formControls: {
      [key: string]: AbstractControl;
    },
    formFields: FormField[],
  ): boolean {
    if (condition) {
      const ctrl = formControls[condition.questionId];
      if (!ctrl || !ctrl.value) return false;
      const nestedParam = condition.nestedParam;
      const ctrlValue = nestedParam ? ctrl && ctrl.value[nestedParam] : ctrl && ctrl.value;
      const ctrlType = formFields.find((field) => field.id === condition.questionId).type;
      if (condition.operator === Operator.EQUALS) {
        return this.isConditionValueEqual(ctrlType, condition.value, ctrlValue);
      } else if (condition.operator === Operator.UNEQUALS) {
        return !this.isConditionValueEqual(ctrlType, condition.value, ctrlValue);
      }
    } else {
      return true;
    }
  }

  private static isConditionValueEqual(fieldType: FormFieldTypeOptions, conditionValue: any, currentValue: any): boolean {
    if (fieldType === 'checkbox' && currentValue) {
      return currentValue.includes(conditionValue);
    }

    if (typeof conditionValue === 'string' && typeof currentValue === 'string') {
      return conditionValue.toLowerCase() === currentValue.toLowerCase();
    }

    if (fieldType === 'integer' && currentValue) {
      return Number(conditionValue) === currentValue;
    }

    if (fieldType === 'floating' && currentValue) {
      const conditionalValueAsNumber = Number(conditionValue.replace(',', '.'));
      return conditionalValueAsNumber === currentValue;
    }

    if (fieldType === 'bool' && currentValue && typeof conditionValue === 'string') {
      return (conditionValue == 'true') ? currentValue === true : currentValue === false;
    }

    return conditionValue === currentValue;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/utils/field-condition-utils.ts